import React from 'react';
import * as Icons from 'react-feather';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError() {
    return {hasError: true};
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Admin panel render error', error, info);
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="flex min-h-screen items-center justify-center bg-gray-100 p-4 dark:bg-dark-1" dir="rtl">
        <section className="box w-full max-w-xl p-8 text-center" role="alert">
          <Icons.AlertOctagon className="mx-auto h-14 w-14 text-theme-6" />
          <h1 className="mt-5 text-2xl font-bold">نمایش این بخش با خطا مواجه شد</h1>
          <p className="mt-3 leading-7 text-gray-600 dark:text-gray-300">
            اطلاعات شما تغییری نکرده است. صفحه را دوباره بارگذاری کنید؛ اگر خطا ادامه داشت به داشبورد بازگردید.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>بارگذاری دوباره</button>
            <a className="btn btn-outline-secondary" href="/dashboard">بازگشت به داشبورد</a>
          </div>
        </section>
      </main>
    );
  }
}
